export default function SearchHelpModal({ open, onClose, theme }) {
  if (!open) return null;

  const rules = [
    'Search checks DA numbers, addresses, descriptions, and Pro intelligence fields your account can access.',
    'Quoted searches like "John Smith" look for that exact phrase.',
    'For Pro accounts, search returns the top 50 database matches, ranked by relevance, then newest lodged date.',
    'Your active filters are applied after search, so some database matches may not be visible.',
    'Rejected and refused DAs appear only when the Rejected filter is on.',
    'Withdrawn and cancelled DAs are hidden from the normal dashboard.',
  ];

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(2,8,18,0.72)',
          zIndex: 999,
          backdropFilter: 'blur(2px)',
        }}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="search-help-title"
        style={{
          position: 'fixed',
          left: '50%',
          bottom: 16,
          transform: 'translateX(-50%)',
          width: 'min(92vw, 390px)',
          background: 'linear-gradient(180deg, #0b1829 0%, #071322 100%)',
          border: `1px solid ${theme.accent}55`,
          borderRadius: 8,
          boxShadow: '0 24px 70px rgba(0,0,0,0.48)',
          padding: 16,
          zIndex: 1000,
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, marginBottom: 10 }}>
          <div>
            <div id="search-help-title" style={{ color: theme.text, fontSize: 16, fontWeight: 850 }}>
              How search works
            </div>
            <div style={{ color: theme.textMuted, fontSize: 12, lineHeight: 1.35, marginTop: 3 }}>
              Search results are narrowed by your current dashboard filters.
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close search help"
            style={{
              width: 32,
              height: 32,
              borderRadius: 8,
              border: `1px solid ${theme.border}`,
              background: 'rgba(10,27,54,0.72)',
              color: theme.textMuted,
              fontSize: 18,
              cursor: 'pointer',
              lineHeight: 1,
              flexShrink: 0,
            }}
          >
            ×
          </button>
        </div>
        <ul style={{ margin: 0, padding: '0 0 0 18px', color: theme.textMuted, fontSize: 12, lineHeight: 1.45 }}>
          {rules.map(rule => (
            <li key={rule} style={{ marginBottom: 7 }}>{rule}</li>
          ))}
        </ul>
      </div>
    </>
  );
}

